import React from 'react'
import HighlightText from '../components/core/home/HighlightText'
import BannerImage1 from '../assets/Images/aboutus1.webp'
import BannerImage2 from '../assets/Images/aboutus2.webp'
import BannerImage3 from '../assets/Images/aboutus3.webp'
import Quote from '../components/core/AboutPage/Quote'
import FoundingStory from '../assets/Images/FoundingStory.png';
import StatsComponent from '../components/core/AboutPage/StatsComponent'
import LearningGrid from '../components/core/AboutPage/LearningGrid'
import ContactForm from '../components/core/AboutPage/ContactForm'
import Footer from '../components/common/Footer'
import RedText from '../components/core/AboutPage/RedText'
// import StatsComp from '../components/core/AboutPage/StatsComp'
import ReviewSlider from '../components/common/ReviewSlider'

const About = () => {
    return (
        <div className=''>
            {/* section 1 */}
            <section className="bg-richblack-700">
                <div className="relative mx-auto flex w-11/12 max-w-maxContent flex-col justify-between gap-10 text-center text-white">
                    <header className="mx-auto py-20 text-4xl font-semibold lg:w-[70%] ">
                        Driving Innovation in Online Education for a
                        <HighlightText text={" Brighter Future"} />
                        <p className="mx-auto mt-3 text-center text-base font-medium text-richblack-300 lg:w-[95%]">
                            Studynotion is at the forefront of driving innovation in online
                            education. We're passionate about creating a brighter future by
                            offering cutting-edge courses, leveraging emerging technologies,
                            and nurturing a vibrant learning community.
                        </p>
                    </header>

                    <div className="sm:h-[70px] lg:h-[150px]"></div>
                    <div className="absolute bottom-0 left-[50%] grid w-[100%] translate-x-[-50%] translate-y-[30%] grid-cols-3 gap-3 lg:gap-5">
                        <img src={BannerImage1} alt="" loading="lazy" />
                        <img src={BannerImage2} alt="" loading="lazy" />
                        <img src={BannerImage3} alt="" loading="lazy" />
                    </div>
                </div>
            </section>

            {/* section 2 */}
            <section className='border-b border-richblack-700'>
                <div className='mx-auto flex-11/12 max-w-maxContent flex-col justify-between gap-10 text-richblack-500'>
                    <div className='h-[100px]'></div>
                    <Quote />
                </div>
            </section>

            {/* section 3 */}
            <section>
                <div className='mx-auto flex w-11/12 max-w-maxContent flex-col justify-between gap-10 text-richblack-900'>

                    {/* Upper side box */}
                    <div className='flex flex-col items-center gap-10 lg:flex-row justify-between'>
                        {/* founding story left box */}
                        <div className='my-24 flex lg:w-[50%] flex-col gap-10'>
                            <RedText text={"Our Founding Story"} />
                            <p className=' text-richblack-300 text-base font-medium lg:w-[95%] '>
                                Our e-learning platform was born out of a shared vision and passion for transforming education. It all began with a group of educators, technologists,
                                and lifelong learners who recognized the need for accessible,
                                flexible, and high-quality learning opportunities in a rapidly
                                evolving digital world.
                            </p>
                            <p className='  text-richblack-300 text-base font-medium lg:w-[95%]'>
                                As experienced educators ourselves, we witnessed firsthand
                                the limitations and challenges of traditional education systems.
                                We believed that education should not be confined to the
                                walls of a classroom or restricted by geographical boundaries.
                                We envisioned a platform that could bridge these gaps and empower
                                individuals from all walks of life to unlock their full potential.
                            </p>
                        </div>

                        {/* founding story right box */}
                        <div>
                            <img src={FoundingStory} alt="FoundigStorry" loading='lazy'
                                className='shadow-[0_0_30px_0] shadow-[#7b2cbf] ' />
                        </div>
                    </div>

                    {/* Lower side box */}
                    <div className='flex flex-col items-center lg:gap-10 lg:flex-row justify-between'>
                        {/* left side box */}
                        <div className='my-24 flex lg:w-[40%] flex-col gap-10'>
                            <h1 className='bg-gradient-to-b from-[#FF512F] to-[#F09819] bg-clip-text text-4xl font-semibold text-transparent lg:w-[70%] '>
                                Our Vision
                            </h1>
                            <p className=' text-richblack-300 text-base font-medium lg:w-[95%] '>
                                With this vision in mind, we set out on a journey to
                                create an e-learning platform that would revolutionize the way
                                people learn. Our team of dedicated experts worked tirelessly to
                                develop a robust and intuitive platform that combines cutting-edge
                                technology with engaging content,
                                fostering a dynamic and interactive learning experience.
                            </p>
                        </div>

                        {/* right side box */}
                        <div className='my-24 flex lg:w-[40%] flex-col gap-10'>
                            <h1 className="bg-gradient-to-b from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text text-4xl font-semibold lg:w-[70%] ">
                                Our Mission
                            </h1>
                            <p className=' text-richblack-300 text-base font-medium lg:w-[95%] '>
                                Our mission goes beyond just delivering courses online. We wanted to create a vibrant community of learners,
                                where individuals can connect, collaborate, and learn from one another. We believe that knowledge thrives in an
                                environment of sharing and dialogue, and we foster this spirit of collaboration through forums, live sessions,
                                and networking opportunities.
                            </p>
                        </div>
                    </div>

                </div>
            </section >

            {/* section 4 */}
            <section >
                <StatsComponent />
                {/* <StatsComp /> */}
            </section >

            {/* section 5 */}
            <section className='w-11/12 max-w-maxContent mx-auto flex flex-col items-center justify-between gap-5 mb-5' >
                <LearningGrid />
                <ContactForm />
            </section >

            <section className=' py-20 mx-auto w-11/12 ' >
                <h1 className='text-center text-4xl font-semibold mt-8 text-richblack-5'>
                    Review from other learners
                </h1>
                <ReviewSlider />
            </section>

            {/* Footer */}
            <Footer />

        </div >
    )
}

export default About